import { render, staticRenderFns } from "./graph_tonnage_par_interface_detail.vue?vue&type=template&id=ed8bc966"
import script from "./graph_tonnage_par_interface_detail.js?vue&type=script&lang=js&external"
export * from "./graph_tonnage_par_interface_detail.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports